import { type FieldType } from '@databases/model/field';
import { type ValueJSON } from '@databases/model/value';
import * as Y from 'yjs';

import { SynchronizedRecord } from '../helpers/synchronized-record.ts';
import { ValueProperties } from '../y-entry.ts';
import { FieldMapping, YFieldMapping, YFieldType, YFieldTypeValues } from '../y-field.ts';

export class YStringValue<T extends FieldType> extends SynchronizedRecord {
  constructor(input: Y.Map<any>) {
    super(input);
  }

  get isEmpty() {
    return !this.value.length;
  }

  get value(): string {
    return this.getString(ValueProperties.value, '');
  }

  set value(data: string) {
    this.set(ValueProperties.value, data);
  }

  get type() {
    return YFieldMapping[
      this.getStringEnum(ValueProperties.type, YFieldTypeValues, YFieldType.TEXT)
    ];
  }

  toJSON(): ValueJSON<T, string> {
    return {
      type: this.type as T,
      value: this.value
    };
  }

  static mapFromJSON<T extends FieldType>(json: ValueJSON<T, string>) {
    return new Y.Map([
      [ValueProperties.type, FieldMapping[json.type]],
      [ValueProperties.value, json.value]
    ]);
  }
}
